import { Badge } from "@mantine/core";
import { useMemo } from "react";
import { SystemEmailCategory } from "../../../services/admin/systemEmails.service";

const CATEGORY_DETAILS: Record<
  SystemEmailCategory,
  { label: string; color: string }
> = {
  report_delivery: { label: "Report delivery", color: "blue" },
  portal_access: { label: "Portal access", color: "violet" },
  portal_auth: { label: "Portal security", color: "grape" },
  staff_account: { label: "Staff account", color: "teal" },
  internal_ops: { label: "Internal operations", color: "orange" },
};

interface SystemEmailCategoryBadgeProps {
  category: SystemEmailCategory;
}

export function SystemEmailCategoryBadge({
  category,
}: SystemEmailCategoryBadgeProps) {
  const details = useMemo(() => CATEGORY_DETAILS[category], [category]);
  return (
    <Badge
      color={details.color}
      miw="max-content"
      styles={{
        label: { overflow: "visible", textOverflow: "clip" },
        root: { maxWidth: "none" },
      }}
      variant="light"
    >
      {details.label}
    </Badge>
  );
}
